/* tslint:disable:max-line-length */
import { landmineNames } from '@mm/constants/landmine-names';
import { TriangleWarningIcon } from '@mm/icons';
import { selectActiveFacebookPage } from '@mm/state/selectors/facebookPageSelector';
import { selectPages } from '@mm/state/selectors/pageSelectors';
import classNames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import { PrimaryButton } from '../../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { useFreeTrialUpgradeModal } from '../../../../../../../common/modals/FreeTrialUpgradeModal/use-free-trial-upgrade-modal';
import css from './UpgradeWarning.module.css';

type Props = {
  pageGroupId?: number;
  className?: string;
};

export const UpgradeWarning = ({ pageGroupId, className }: Props) => {
  const { openFreeTrialUpgradeModalPromotional } = useFreeTrialUpgradeModal();
  const activeFacebookPage = useSelector(selectActiveFacebookPage);
  const pages = useSelector(selectPages);
  const fileteredPagesByGroupId = pages.filter(
    page => page.pageGroupId === pageGroupId,
  );
  const paidPage =
    activeFacebookPage?.subscription || activeFacebookPage?.redemption;
  const isEmailWidgetPresent = !!fileteredPagesByGroupId.find(page =>
    page.platforms.includes('email'),
  );
  const isSmsWidgetPresent = !!fileteredPagesByGroupId.find(page =>
    page.platforms.includes('sms'),
  );

  const text =
    isSmsWidgetPresent && isEmailWidgetPresent
      ? 'Email / SMS blocks'
      : isEmailWidgetPresent
      ? 'Email blocks'
      : isSmsWidgetPresent
      ? 'SMS block'
      : 'Paid blocks';

  if (paidPage || (!paidPage && !isEmailWidgetPresent && !isSmsWidgetPresent)) {
    return null;
  }

  return (
    <div className={classNames(className, css.container)}>
      <TriangleWarningIcon />

      <span className={css.text}>
        {text} won't send unless the account is upgraded
      </span>
      <PrimaryButton
        className={css.button}
        onClick={() =>
          openFreeTrialUpgradeModalPromotional({
            landmineName: landmineNames.AUTOMATIONS_UPGRADE_WARNING,
          })
        }
      >
        Upgrade
      </PrimaryButton>
    </div>
  );
};
